<template>
  <div>
    <div class="color-btn" :class="[color, { 'not-selected': color !== selectedColor }]" v-for="(color, index) in material" :key="'m' + color" @click="onSelect(color)" v-ripple></div>
  </div>
</template>

<script>
export default {
  data: () => ({
    selectedColor: '',
    material: [
      'red',
      'pink',
      'purple',
      'deep-purple',
      'indigo',
      'blue',
      'light-blue',
      'cyan',
      'teal',
      'green',
      'light-green',
      'lime',
      'amber',
      'orange',
      'deep-orange',
      'brown'
    ]
  }),

  computed: {},

  props: ['originalColor'],

  methods: {
    onSelect(color) {
      this.selectedColor = color;
      this.$emit('input', color);
    }
  },

  mounted() {
    this.selectedColor = this.originalColor;
  }
};
</script>

<style scoped>
.color-btn {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-left: 5px;
  cursor: pointer;
  border-radius: 4px;
}

.not-selected {
  margin: 7px;
  width: 26px;
  height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/ColorPicker.vue